"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;